import { useEffect, useState } from "react";
import { FaRegSquare } from "react-icons/fa";
import { FaSquareCheck } from "react-icons/fa6";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch } from "react-redux";
import {
  InputField,
  Modal,
  PhoneInput,
  TextComponent,
} from "../../../../components";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import styles from "./index.module.css";
import { CompanyMiddleware } from "../../../../Store/Middlewares/CompanyMiddleware";
import Switch from "../../../../components/Switch/Switch";

const EditCustomer = ({
  openModel,
  setopenModel,
  details,
  setDetails
}) => {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [status, setStatus] = useState(0);

  useEffect(() => {
    if (details) {
      setName(details?.name ? details?.name : "");
      setAddress(details?.address ? details?.address : "");
      setEmail(details?.email ? details?.email : "");
      setLastName(details?.last_name ? details?.last_name : "");
      setFirstName(details?.first_name ? details?.first_name : "");
      setContactNo(details?.contact_no ? details?.contact_no : "");
      setStatus(details?.status === "active" ? 1 : 0);
    }
  }, [details, !setopenModel]);

  const onReset = () => {
    setName("");
    setAddress("");
    setEmail("");
    setFirstName("");
    setLastName("");
    setContactNo("");
    setStatus(0);
  };

  const onUpdateStaff = () => {
    let userData = {
      id: details?.id,
      name,
      address,
      email,
      contactNo,
      firstName,
      lastName,
      status,
    };
    if (
      !name ||
      !address ||
      !email ||
      !firstName ||
      !lastName
      //   ||!contactNo
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        })
      );
    } else {
      dispatch(CompanyMiddleware.updateDealership(userData)).then(() => {
        setopenModel(false);
        setIsSuccessFulModal(true);
        setDetails(null);
        // getData();
      });
    }
  };
  return (
    <div>
      <Modal
        width={"600px"}
        open={openModel}
        onCancel={() => {
          setopenModel(false);
          setDetails(null);
          onReset();
        }}
        twoButton
        okBtnTitle={"Save Information"}
        cancelBtnTitle={"Go Back"}
        onClickCancelButton={() => {
          setopenModel(false);
          setDetails(null);
          onReset();
        }}
        onClickOkButton={onUpdateStaff}
      >
        <div className={styles.mainCont}>
          <TextComponent
            text={"Edit Dealership"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <TextComponent
            text={"Update Profile Information"}
            style={{ color: "var(--light-text)" }}
          />

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"First Name"}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder={"Write here..."}
              required
            />
            <InputField
              className={styles.input}
              label={"Last Name"}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder={"Write here..."}
              required
              //   disabled={true}
            />
          </div>

          <div className={styles.twoInput}>
            {/* <InputField
              className={styles.input}
              label={"Name"}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={"Write here..."}
            /> */}
            <InputField
              className={styles.input}
              label={"Email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={"Write here..."}
              type="email"
              required
              //   disabled={true}
            />
            <PhoneInput
              label={"Contact number"}
              placeholder={"(301) 580-7410"}
              className={styles.input}
              value={contactNo}
              onChange={setContactNo}
              required
            />
          </div>

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"Address"}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder={"Write here..."}
              style={{ width: "100%" }}
              required
            />
          </div>
          <div className="flex-start">
            <div style={{ marginRight: "10px" }}>
              <Switch
                isChecked={status == 1 ? true : false}
                activeColor={"var(--secondary-color)"}
                inactiveColor={"var(--light-grey)"}
                onChange={() => {
                  setStatus(status == 1 ? 0 : 1);
                }}
                size="small"
              />
            </div>
            <TextComponent
              text={"Active Status"}
              style={{ fontSize: "14px", color: "var(--light-text)" }}
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Changes saved"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setIsSuccessFulModal(false)}
      ></Modal>
    </div>
  );
};

export default EditCustomer;
